module.exports = " <div class=mdt-offers-upperwrap _v-15f73ffb=\"\"> <market-section title=Hotelería :articles=articles section-type=hotels _v-15f73ffb=\"\"></market-section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-15f73ffb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/hotel-offers.vue
// module id = 405
// module chunks = 0